import { TypedDocumentNode } from '@apollo/client';
import { useQuery, useReactiveVar } from '@apollo/client/react';
import { Query, QueryGetVisitorByIdArgs } from 'graphql/generated/graphqlTypes';
import { GET_VISITOR_DETAILS } from 'graphql/v2/queries';
import { useEffect } from 'react';
import { authVar } from 'state/vars';
import { TranslatedHookProps } from 'v2/hooks/hooks.types';

// Typing the documents (instead of passing generics to the Apollo hooks) avoids the deprecated hook signatures.
const GET_VISITOR_DETAILS_TYPED: TypedDocumentNode<
  Pick<Query, 'getVisitorById'>,
  QueryGetVisitorByIdArgs
> = GET_VISITOR_DETAILS;

const useCurrentUser = ({ translation, handleFetchError }: TranslatedHookProps) => {
  const { user } = useReactiveVar(authVar);

  const {
    data,
    loading: currentUserLoading,
    error: currentUserError
  } = useQuery(GET_VISITOR_DETAILS_TYPED, {
    variables: { id: user?.id ?? '' },
    skip: !user?.id
  });

  useEffect(() => {
    if (currentUserError) {
      handleFetchError(translation.user_details_error_fetching);
      console.error(currentUserError);
    }
  }, [currentUserError, handleFetchError, translation.user_details_error_fetching]);

  return {
    currentUser: data?.getVisitorById,
    currentUserLoading
  };
};

export default useCurrentUser;
